/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsLabourAnalysisCtrl
 * @description A report with sales grouped by Item Category and report interval
 */
angular.module('mercury.modules.reports.labour')
.controller('ReportsLabourAnalysisCtrl', ["$scope", "$filter", "title", "$q", "reporttime", "LabourFactory", function($scope, $filter, title, $q, reporttime, LabourFactory) {

  title.set('Budget');
  var costCentres = ['Food', 'Beverage']; // todo: fetch from backend
  $scope.costCentreOptions = costCentres.slice();
  $scope.costCentreOptions.unshift('All'); // copy the array and prepend "All" to it

  $scope.selectedCostCentre = 'All';

  $scope.chartOptions = {
    seriesType: 'bars',
    vAxis: {
      minValue: 0,
      format: '#\'%\''
    },
    hAxis: {
      ticks: [],
      gridlines: {
        color: 'transparent'
      }
    },
    legend: {position: 'none'}
  };

  $scope.graphCols = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Rostered Wage %', format: 'number', type: 'number', key: 'wageSalesBudgetPercentage'},
    {label: 'Actual Wage %', format: 'number', type: 'number', key: 'wageSalesActualPercentage'}
  ];

  function processData(labourBudget) {
    // We need to assume the number of cost centres can change, so we need to make our result structure flexible

    var result = {};
    $scope.costCentreOptions.forEach(function(costCentre) {
      result[costCentre] = [];
    });

    // Loop through each interval in the sales result and create an array element for each cost centre (and one for all)
    labourBudget.forEach(function(labour) {

      var intervalSalesActual = {};
      var intervalSalesBudget = {};
      var intervalWagesActual = {};
      var intervalWagesBudget = {};
      var intervalWageSalesBudgetPercentage = {};
      var intervalWageSalesActualPercentage = {};

      costCentres.forEach(function(costCentre) {
        intervalSalesActual[costCentre] = 0;
        intervalSalesBudget[costCentre] = 0;
        intervalWagesActual[costCentre] = 0;
        intervalWagesBudget[costCentre] = 0;
        intervalWageSalesBudgetPercentage[costCentre] = 0;
        intervalWageSalesActualPercentage[costCentre] = 0;
      });

      result.All.push({
        startTime: moment(labour.startTime).toDate(),
        label: $filter('reporttimeformat')(labour.startTime),
        moment: moment(labour.startTime),
        salesActual: labour.actualSalesEx,
        salesBudget: labour.budgetedSalesEx,
        wagesActual: labour.actualWageCost,
        wagesBudget: labour.rosterWageCost,
        wageSalesBudgetPercentage: (labour.rosterWageCost !== 0 && labour.budgetedSalesEx !== 0) ? (labour.rosterWageCost / labour.budgetedSalesEx) * 100 : 0,
        wageSalesActualPercentage: (labour.actualWageCost !== 0 && labour.actualSalesEx !== 0) ? (labour.actualWageCost / labour.actualSalesEx) * 100 : 0,
        wageSalesBudgetTablePercentage: (labour.rosterWageCost !== 0 && labour.budgetedSalesEx !== 0) ? (labour.rosterWageCost / labour.budgetedSalesEx) * 100 : 0,
        wageSalesActualTablePercentage: (labour.actualWageCost !== 0 && labour.actualSalesEx !== 0) ? (labour.actualWageCost / labour.actualSalesEx) * 100 : 0
      });

      labour.categories.forEach(function(category) {
        costCentres.forEach(function(costCentre) {
          if (category.posItemCategoryName == costCentre) {
            intervalSalesActual[costCentre] = category.actualSalesEx;
            intervalSalesBudget[costCentre] = category.budgetedSalesEx;
            intervalWagesActual[costCentre] = category.actualWageCost;
            intervalWagesBudget[costCentre] = category.rosterWageCost;
            intervalWageSalesBudgetPercentage[costCentre] = (category.rosterWageCost !== 0 && category.budgetedSalesEx !== 0) ?
            (category.rosterWageCost / category.budgetedSalesEx) * 100 : 0;
            intervalWageSalesActualPercentage[costCentre] = (category.actualWageCost !== 0 && category.actualSalesEx !== 0) ?
            (category.actualWageCost / category.actualSalesEx) * 100 : 0;
          }
        });
      });

      costCentres.forEach(function(costCentre) {
        result[costCentre].push({
          startTime: moment(labour.startTime).toDate(),
          label: $filter('reporttimeformat')(labour.startTime),
          moment: moment(labour.startTime),
          salesActual: intervalSalesActual[costCentre],
          salesBudget: intervalSalesBudget[costCentre],
          wagesActual: intervalWagesActual[costCentre],
          wagesBudget: intervalWagesBudget[costCentre],
          wageSalesBudgetPercentage: intervalWageSalesBudgetPercentage[costCentre],
          wageSalesActualPercentage: intervalWageSalesActualPercentage[costCentre],
          wageSalesBudgetTablePercentage: intervalWageSalesBudgetPercentage[costCentre],
          wageSalesActualTablePercentage: intervalWageSalesActualPercentage[costCentre]
        });
      });

    });

    return result;
  }

  $scope.loading = $q.all({
    labourBudget: LabourFactory.LabourBudgetAnalysis(reporttime.start(), reporttime.end(), '01:00:00:00')
  });

  $scope.loading.then(function(results) {

    $scope.allTableData = processData(results.labourBudget);
    $scope.allChartData = $scope.allTableData;

    var axisTicks = [];
    if (reporttime.reportType() == 'week') {
      $scope.allTableData.All.forEach(function(interval) {
        // only put one axis label per day
        axisTicks.push({
          v: interval.startTime,
          f: interval.label
        });
      });
    } else {
      $scope.allTableData.All.forEach(function(interval) {
        axisTicks.push({
          v: interval.startTime,
          f: interval.label
        });
      });
    }

    $scope.chartOptions.hAxis.ticks = axisTicks;

    $scope.reportTableData = $scope.allTableData;
    $scope.reportChartData = $scope.allTableData;

    $scope.updateCostCentre();

  });

  $scope.updateCostCentre = function() {
    $scope.reportTableData = $scope.allTableData[$scope.selectedCostCentre];
    $scope.reportChartData = $scope.allTableData[$scope.selectedCostCentre];
  };

}]);
